import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const EmptyContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px;
`;

export const Container = styled.div`
	display: grid;
	gap: 20px;
	overflow-x: auto;
	width: 100%;

	.population-see-more-table {
		border-spacing: 0 8px;
		border-collapse: separate;
	}
`;

export const DefaultContainer = styled.div`
	background-color: ${tokens.color_white};
	padding: 20px;
	border-radius: 8px;
	border: 1px solid ${tokens.color_gray_medium};
`;

export const ContainerTables = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(368px, 500px));
	gap: 20px;
	overflow-x: auto;
	width: 100%;
`;
